import React, { useState } from "react";
import "./Department.css";
import axios from "axios";
import DepartmentTable from "./DepartmentTable.jsx";
import DepartmentForm from "./DepartmentForm.jsx";
import DepartmentFormEdit from "./DepartmentFormEdit.jsx";
// import { BrowserRouter as Router, Route, Link } from "react-router-dom";

// function DepartmentTableF() {
//   return <DepartmentTable/>;
// }
// function DepartmentFormF() {
//   return  <DepartmentForm onDepartmentSubmit={handleDepartmentSubmit}/>;
// }

// function handleDepartmentSubmit(e) {
//   e.preventDefault();
//   console.log(e);

// }

function Department(props) {
  const [table, setTable] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState({});

  const handleDepartmentSubmit = (event) => {
    event.preventDefault();
    if (
      event.target[0].value !== "" &&
      event.target[1].value !== "" &&
      event.target[2].value !== ""
    ) {
      setTable(true);

      let body = {
        CompanyID: event.target[0].value,
        hod: event.target[1].value,
        DepartmentName: event.target[2].value,
      };
      //  let body= "CompanyID=" + event.target[0].value + "&Department=" + event.target[1].value;
      //  let body= "FenilKaneria";
      axios
        .post(
          "https://almawridems.javedahmadghamidi.com/api/ems/department",
          body,
          {
            headers: {
              authorization: localStorage.getItem("token") || "",
            },
          }
        )
        .then((res) => {
          setTable(false);
          setTable(true);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      alert("Please Fill All Fields");
    }
  };
  const handleAddDepartment = () => {
    // // console.log("clicked1");
    setTable(false);
  };
  const handleEditDepartment = (e) => {
    // console.log(e);
    // console.log("clicked6");
    setEditForm(true);
    setEditData(e);
  };
  const handleEditFormClose = () => {
    // console.log("clicked5");
    setEditData(false);
  };
  const handleFormClose = () => {
    // // console.log("clicked1");
    setTable(true);
  };
  const handleDepartmentEditUpdate = (info, newInfo) => {
    newInfo.preventDefault();
    let body = {
      // ...info,CompanyID:formData1,Department:formData2

      CompanyID: newInfo.target[0].value,
      DepartmentName: newInfo.target[1].value,
    };
    console.log("update", body);
    axios
      .put(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/department/" +
          info["_id"],
        body,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        setTable(false);
        setTable(true);
      })
      .catch((err) => {
        console.log(err);
      });
    setEditForm(false);
  };

  return (
    <React.Fragment>
      {table ? (
        editForm ? (
          <DepartmentFormEdit
            onDepartmentEditUpdate={handleDepartmentEditUpdate}
            onFormEditClose={handleEditFormClose}
            editData={editData}
          />
        ) : (
          <DepartmentTable
            onAddDepartment={handleAddDepartment}
            onEditDepartment={handleEditDepartment}
            setTable={setTable}
          />
        )
      ) : (
        <DepartmentForm
          onDepartmentSubmit={handleDepartmentSubmit}
          onFormClose={handleFormClose}
        />
      )}
    </React.Fragment>
  );
}

export default Department;
